import { AppStateWithData } from "../../redux/AppStateWithData";
import { UserProfile } from "../../models";

export const getUsersInputAutocomplete = (state: AppStateWithData) => (text: string): Promise<UserProfile[]> => {
    return Promise.resolve(state.data.globalData.users.data.filter(x => x.tag.includes(text)))
}